import { Flex, Modal } from 'antd'
import React from 'react'
import { BlogWriterClient } from '~/agents/blogWriter/client'
import { CustomerSupportClient } from '~/agents/customerSupport/client'
import { ExecutiveAssistantClient } from '~/agents/executiveAssistant/client'
import { LegalAssistantClient } from '~/agents/legalAssistant/client'
import { ReceptionistClient } from '~/agents/receptionist/client'
import { SalesAssistantClient } from '~/agents/salesAssistant/client'
import { SocialMediaManagerClient } from '~/agents/socialMediaManager/client'
import { useUserContext } from '~/core/context'
import { Api } from '~/core/trpc'
import { AppSessionType } from '~/features/appSession/common'
import { DesignBox } from '~/plugins/designbox'

type Props = {
  appKey: string
  appSession: AppSessionType
  onSuccess: () => Promise<void> | void
  onClose: () => void
}

const WIDTH_ARBITRARY = 660

export const Settings: React.FC<Props> = ({
  appKey,
  appSession: _appSessionInitial,
  onSuccess,
  onClose,
}) => {
  const { session } = useUserContext()

  const query = Api.appSession.findUnique.useQuery(
    {
      where: { id: _appSessionInitial.id },
    },
    { keepPreviousData: false, cacheTime: 0 },
  )

  const appSession = query.data as AppSessionType

  const isStatusToOnboard = appSession?.status === 'TO_ONBOARD'
  const isCorrupted = appSession?.statusOnboarding === 'CORRUPTED'
  const isOnboardingPending = appSession?.statusOnboarding === 'PENDING'

  const isOnboarding = isStatusToOnboard && (isCorrupted || isOnboardingPending)

  const handleClose = () => {
    onSuccess()
    onClose()
  }

  return (
    <>
      <Modal
        open={true}
        onCancel={handleClose}
        closeIcon={!isOnboarding}
        footer={false}
        width={WIDTH_ARBITRARY}
        style={{ top: '50px', bottom: '50px' }}
        styles={{
          content: {
            padding: 0,
            overflow: 'hidden',
          },
          footer: {
            margin: 0,
          },
        }}
      >
        <Flex
          vertical
          style={{
            padding: '36px 60px 36px 60px',
            height: 'calc(-100px + 100vh)',
            overflowY: 'auto',
          }}
        >
          {!appSession ? (
            <DesignBox.LoaderOverlay />
          ) : appKey === SocialMediaManagerClient.Agent.key ? (
            <>
              {isOnboarding ? (
                <SocialMediaManagerClient.Onboarding
                  appSession={appSession}
                  user={session.user}
                  onSubmit={handleClose}
                />
              ) : (
                <SocialMediaManagerClient.Settings
                  appSession={appSession}
                  user={session.user}
                />
              )}
            </>
          ) : appKey === BlogWriterClient.Agent.key ? (
            <>
              {isOnboarding ? (
                <BlogWriterClient.Onboarding
                  appSession={appSession}
                  user={session.user}
                  onSubmit={handleClose}
                />
              ) : (
                <BlogWriterClient.Settings
                  appSession={appSession}
                  user={session.user}
                />
              )}
            </>
          ) : appKey === ExecutiveAssistantClient.Agent.key ? (
            <>
              {isOnboarding ? (
                <ExecutiveAssistantClient.Onboarding
                  appSession={appSession}
                  user={session.user}
                  onSubmit={handleClose}
                />
              ) : (
                <ExecutiveAssistantClient.Settings
                  appSession={appSession}
                  user={session.user}
                />
              )}
            </>
          ) : appKey === LegalAssistantClient.Agent.key ? (
            <>
              {isOnboarding ? (
                <LegalAssistantClient.Onboarding
                  appSession={appSession}
                  user={session.user}
                  onSubmit={handleClose}
                />
              ) : (
                <LegalAssistantClient.Settings
                  appSession={appSession}
                  user={session.user}
                />
              )}
            </>
          ) : appKey === CustomerSupportClient.Agent.key ? (
            <>
              {isOnboarding ? (
                <CustomerSupportClient.Onboarding
                  appSession={appSession}
                  user={session.user}
                  onSubmit={handleClose}
                />
              ) : (
                <CustomerSupportClient.Settings
                  appSession={appSession}
                  user={session.user}
                />
              )}
            </>
          ) : appKey === SalesAssistantClient.Agent.key ? (
            <>
              {isOnboarding ? (
                <SalesAssistantClient.Onboarding
                  appSession={appSession}
                  user={session.user}
                  onSubmit={handleClose}
                />
              ) : (
                <SalesAssistantClient.Settings
                  appSession={appSession}
                  user={session.user}
                />
              )}
            </>
          ) : appKey === ReceptionistClient.Agent.key ? (
            <>
              {isOnboarding ? (
                <ReceptionistClient.Onboarding
                  appSession={appSession}
                  user={session.user}
                  onSubmit={handleClose}
                />
              ) : (
                <ReceptionistClient.Settings
                  appSession={appSession}
                  user={session.user}
                />
              )}
            </>
          ) : (
            <></>
          )}
        </Flex>
      </Modal>
    </>
  )
}
